var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTarget = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.02 8h-2.045a6.504 6.504 0 0 0-6.004-5.977V-.039h-1v2.065A6.505 6.505 0 0 0 2.025 8H-.02v1h2.045a6.505 6.505 0 0 0 5.945 5.974V17h1v-2.023A6.5 6.5 0 0 0 14.974 9h2.045V8zm-8.049 5.977V12h-1v1.974A5.51 5.51 0 0 1 3.025 9H4.98V8H3.025a5.51 5.51 0 0 1 4.946-4.974v1.935h1V3.023A5.51 5.51 0 0 1 13.975 8H12.02v1h1.955a5.51 5.51 0 0 1-5.004 4.977"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTarget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/target.svg";